export default {
  allocationBudget: "Allocation Budget",
  additionalDetails: "Additional Details",
  addProject: "Add New Project",
  editProject: "Edit Project",
  addAdvertiser: "Add New Advertiser",
  addBusinessGoal: "Add New Business Goal",
  editBusinessGoal: "Edit Business Goal",
  addBusinessGoalShort: "Add Business Goal",
  addNewPage: "Add a New Page",
  advertiserProfile: "Advertiser Profile",
  advertiserName: "Advertiser Name",
  advertiserMetrics: "Advertiser Metrics",
  clientNuances: "Client Nuances",
  armCandyInvestmentData: "Arm Candy Investment Data",
  advertiserBusinessData: "Advertiser Business Data",
  advertiserHistoricalMediaInvestmentData: "Advertiser Historical Media Investment Data",
  webAnalyticsData: "Web Analytics Data",
  dimensionsAndMetrics: "Dimensions & Metrics",
  sourceFields: "Fields",
  clientStatus: "Client Status",
  yearsActive: "Years Active",
  website: "Website",
  startEndDate: "Start / End Date",
  locationDimension: "Location Dimension",
  years: "Years",
  channels: "Channels",
  numberOfDmas: "# of DMAs",
  dataDimension: "Data Dimension",
  lastDataUpload: "Last Data Upload",
  businessDataType: "Business Data Type",
  webAnalyticsProvider: "Web Analytics Provider",
  availability: "Availability",
  available: "Available",
  unavailable: "Unavailable",
  lastUpdated: "Last Updated",
  approved: "Approved",
  noDataGenerated: "No Data Generated",
  scenarioOutputOutdated: "Output Outdated",
  campaignKpiBudget: "Campaign KPI Budget",
  accountManagement: "Account Management",
  advertisersManagement: "Advertiser Management",
  addNewAccount: "Add New Account",
  added: "Added",
  accentColor: "Accent Color",
  backToHomepage: "Back to Homepage",
  estimatedAudienceSize: "Estimated Audience Size",
  input: "Input",
  output: "Output",
  planByBudget: "Plan by Budget",
  planByKpiGoal: "Plan by KPI Goal",
  budget: "Budget",
  homepage: "Homepage",
  colorPalette: "Color palette",
  chooseTemplateToUpdate: "Select template to update",
  last10Jobs: "Latest Generations",
  shareProject: "Share Project",
  chartConfiguration: "Chart Configuration",
  colorTheme: "Color Theme",
  scenarios: "Scenarios",
  selectScenariosToGenerate: "Select Scenarios to Generate",
  newOutputForSelectedScenarios: "New output results will be generated for the selected plan scenarios",
  selectAll: "Select All",
  compareScenarios: "Compare Scenarios",
  channelBudgetAllocation: "Channel Budget Allocation",
  channelBudget: "Channel Budget",
  citiesAndZips: "Cities and ZIPs Selection",
  campaignId: "Campaign ID",
  createNewPassword: "Create new password",
  chartSettings: "Chart Settings",
  countableMetrics: "Countable Metrics",
  dropZone: "Drag and drop<br />a picture here",
  dimensions: "Dimensions",
  metrics: "Metrics",
  dimensionBased: "Dimension Based",
  dateRanges: "Date Ranges",
  dateRange: "Date Range",
  emailHasBeenSent: "Email has been sent",
  editAccount: "Edit Account",
  editAdvertiser: "Edit Advertiser",
  explore: "Explore",
  forgotPasswordTitle: "Forgot password?",
  familyName: "Family",
  logoImage: "Logo",
  logoText: "CYRIS",
  newBudget: "Net Budget",
  campaignKPIS: "Campaign KPIs",
  channelSelections: "Channel Selections (optional)",
  channelExclusions: "Channel Exclusions (optional)",
  kpiGoalValue: "KPI Goal Value",
  kpiGoal: "KPI Goal",
  skipChannelPrediction: "No more other channels are expected to be recommended in the Output",
  newBudgetAllocations: "KPIs - Net Budget Allocation",
  grossBudget: "Gross Budget",
  markets: "Markets",
  demo: "Demo",
  demos: "Demos",
  moreFilters: "More Filters",
  mainPage: "Main Page",
  mediaPlans: "Media Plans",
  name: "Name",
  noDataAvailable: "No Data Available",
  noMediaPlansAvailable: "No Media Plans Available",
  presets: "Presets",
  passwordHasBeenSuccessfullyChanged: "Password has been successfully changed",
  planModule: "Plan Module",
  plansCount: "# of Plans Created",
  plan: "Plan",
  planOwners: "Plan Owners",
  privateTemplates: "Private Templates",
  publicTemplates: "Public Templates",
  planDetails: "Plan Details",
  projectOwners: "Project Owners",
  signIn: "Sign in",
  ownedBy: "Owned By",
  publishDate: "Publish Date",
  lastModified: "Last Modified",
  showColumns: "Show Columns",
  grandTotal: "Grand Total",
  total: "Total",
  startDate: "Start Date",
  endDate: "End Date",
  netBudget: "Net Budget",
  standardMetrics: "Standard Metrics",
  selectColumns: "Select Columns",
  selectPlan: "Select Plan",
  selectPlanHint: "Only Plans with min 2 Scenarios are listed",
  selectScenarios: "Select Scenarios",
  selectScenariosHint: "At least 2 Scenarios must be selected",
  scenarioOwners: "Scenario Owners",
  selectOutputTemplate: "Select Output Template",
  summaryConfiguration: "Summary Configuration",
  summarySettings: "Summary Settings",
  tableConfiguration: "Table Configuration",
  titleResetPassword: "Reset Password",
  templateManagement: "Template Management",
  templateName: "Template name",
  businessGoalOwners: "Business Goal Owners",
  projectsTemplateManagement: "Projects Template Management",
  userManagement: "User Management",
  widgetsLibrary: "Widgets Library",
  createProjectTemplate: (type: string) => `Create ${type} template`,
  advertisersList: "Advertisers List",
};
